module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_tablet@2x-99eeb336f17af7f2f76e457d01bf0b8c.png";